import React from 'react'
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper'
import HeaderFooterWrapper from './header-footer-wrapper'

const withComponentBase = (Component, options = {}) => props => {
  if (typeof options === 'function') {
    options = options(props)
  }

  const {
    withHeaderFooter = false,
    headerStyles,
    footerStyles,
    headerContainerStyles,
    footerContainerStyles,
    wrapHeaderFooterChildren = false,
  } = typeof options === 'function' ? options(props) : options

  return (
    <ConditionalWrapper
      condition={withHeaderFooter}
      wrapper={HeaderFooterWrapper}
      headerStyles={headerStyles}
      footerStyles={footerStyles}
      wrapChildren={wrapHeaderFooterChildren}
      headerContainerStyles={headerContainerStyles}
      footerContainerStyles={footerContainerStyles}
      {...props}
    >
      <Component {...props} />
    </ConditionalWrapper>
  )
}

export default withComponentBase
